import React from 'react';
import { cn } from '@app/shared/utils/common';

interface BadgeProps {
  children: React.ReactNode;
  className?: string;
}

export function Badge({ children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'h-fit rounded-lg bg-secondary px-2 py-1.5 text-sm font-medium leading-none text-[#0b87f9]',
        className
      )}
    >
      {children}
    </span>
  );
}
